import React from 'react'
import PropTypes from 'react-proptypes'
import { CurrenciesIcon } from 'assets/currencies'
import * as d3 from 'd3'

class LabelNames extends React.Component {
  state = {
    labels: [],
  }

  shouldComponentUpdate = nextProps => {
    return nextProps.slices !== this.props.slices
  }

  componentWillMount = () => this.createForce()

  createForce = () => {
    const { slices, outerArc } = this.props
    const labels = slices.map(slice => {
      const pos = outerArc.centroid(slice)
      return {
        data: slice.data,
        x: pos[0],
        y: pos[1],
        r: 25,
      }
    })
    this.force = d3
      .forceSimulation(labels)
      .force(
        'collide',
        d3.forceCollide().radius(function(d) {
          return d.r
        })
      )
      .stop()
    for (
      var i = 0,
        n = Math.ceil(
          Math.log(this.force.alphaMin()) /
            Math.log(1 - this.force.alphaDecay())
        );
      i < n;
      ++i
    ) {
      this.force.tick()
    }
    this.setState({ labels })
  }

  render() {
    const { category } = this.props
    const { labels } = this.state
    return (
      <g className="labelNames">
        {labels.map((d, i) => {
          // OTHERS
          if (!d.data[category]) {
            return (
              <g transform={`translate(${d.x}, ${d.y})`} key={i}>
                <CurrenciesIcon more width={50} height={50} x={-25} y={-25} />
              </g>
            )
          }
          return (
            <g transform={`translate(${d.x}, ${d.y})`} key={i}>
              <CurrenciesIcon
                currency={d.data[category]}
                width={50}
                height={50}
                x={-25}
                y={-25}
              />
            </g>
          )
        })}
      </g>
    )
  }
}
LabelNames.propTypes = {
  slices: PropTypes.array.isRequired,
  outerArc: PropTypes.func.isRequired,
  radius: PropTypes.number.isRequired,
  category: PropTypes.string.isRequired,
}
export default LabelNames



// WEBPACK FOOTER //
// ./src/components/Donut/LabelNames.js